export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M10 20.5v-6h4v6h5v-8h3l-10-9-10 9h3v8z\"/>"
};